import { Tag } from 'antd';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import {
  BellScheduleView,
  BellScheduleEdit,
  BellScheduleCopy,
  BellScheduleDelete,
  BellScheduleApply,
} from 'entities/bell-schedule';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';
import type { BellSchedule } from 'services/api';

export const getColumns = ({
  refreshTable,
}: {
  refreshTable: () => void;
}): AppTableColumn<BellSchedule>[] => [
  {
    key: 'name',
    title: 'Название',
    dataIndex: ['name'],
  },
  {
    key: 'isApplied',
    title: '',
    dataIndex: ['isApplied'],
    maxWidth: '5%',
    render: (isApplied: boolean) => (isApplied ? <Tag color="green">Применено</Tag> : null),
  },
  {
    key: 'actions',
    title: '',
    dataIndex: [],
    maxWidth: '350px',
    render: (_, record: BellSchedule) => (
      <AppFlex direction="row" alignItems="center">
        {!record.isApplied && (
          <BellScheduleApply bellSchedule={record} refreshTable={refreshTable} />
        )}
        <BellScheduleView bellSchedule={record} />
        {record.isBaseSchedule ? null : (
          <BellScheduleEdit bellSchedule={record} refreshTable={refreshTable} />
        )}
        <BellScheduleCopy bellSchedule={record} refreshTable={refreshTable} />
        {record.isBaseSchedule || record.isApplied ? null : (
          <BellScheduleDelete bellSchedule={record} refreshTable={refreshTable} />
        )}
      </AppFlex>
    ),
  },
];
